import {useApiRemove} from "../../../../../lib/HttpService";
import {PATH} from "./const";
import {StubbornDatasource} from "../../../../../application/business/StubbornAsset";

export const useEditionDatasourceRemove = () => useApiRemove<StubbornDatasource>(PATH);
